var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketDeep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.632 15.445a1 1 0 01-.633 1.265c-1.491.497-2.29 1.748-2.722 3.042-.153.46-.252.905-.316 1.287a8.543 8.543 0 001.287-.316c1.294-.431 2.545-1.23 3.042-2.722a1 1 0 111.897.633c-.78 2.342-2.725 3.46-4.306 3.987a10.752 10.752 0 01-3.005.53H1.85v-1h-1v-.027a4.383 4.383 0 01.008-.247 10.753 10.753 0 01.522-2.757c.527-1.582 1.644-3.526 3.987-4.307a1 1 0 011.265.632zm-4.783 6.706h-1a1 1 0 001 1v-1zm1 0v.002-.001z",
    fill: "#624DE3",
    fillOpacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.451 2.549c-1.06-.143-3.555-.142-6.116 2.419l-6.96 6.96 3.697 3.697 6.96-6.96c2.561-2.56 2.561-5.056 2.42-6.116zm.37-1.968c-1.463-.218-4.716-.212-7.9 2.972l-7.668 7.668a1 1 0 000 1.414l5.112 5.112a1 1 0 001.414 0l7.668-7.668c3.184-3.184 3.19-6.437 2.972-7.9M21.82.582A1.9 1.9 0 0123.42 2.18",
    fill: "#624DE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.462 9.65a1 1 0 011 1v7.293a1.903 1.903 0 01-.558 1.346l-3.653 3.653a1.904 1.904 0 01-3.212-.972l-.947-4.734a1 1 0 011.961-.393l.911 4.558 3.498-3.498V10.65a1 1 0 011-1zm-4.625 11.878zM5.328 4.683c.231-.095.479-.145.729-.145h7.293a1 1 0 110 2H6.097l-3.498 3.498 4.557.911a1 1 0 01-.392 1.962l-4.734-.947a1.904 1.904 0 01-.972-3.213L4.71 5.096l.65.65-.65-.65c.176-.177.386-.317.617-.413zm-2.905 5.318l-.02.094-.17.849m.19-.943l-.02.094",
    fill: "#624DE3"
  })));
}
export default SvgRocketDeep;